import React from 'react';

import Box from '@mui/material/Box';

import { makeStyles } from 'tss-react/mui';

import { euroLandWidgets } from '@lumirental/lumi-web-shared/lib/constants/IR/content';

import { BannerBlock, ContactBlock } from '@lumirental/lumi-web-components-ui';

import EuroLandWidget from '@/company/IR/blocks/EuroLandWidget/EuroLandWidget';

import styles from './AnnouncementsContainer.style';

const useStyles = makeStyles()(styles);

export default function AnnouncementsContainer() {
  const { classes } = useStyles();

  return (
    <>
      <BannerBlock pageKey="announcements" />
      <EuroLandWidget widgetSrc={euroLandWidgets.announcements.link} />
      <Box className={`${classes.wrapper} ${classes.grayBg}`}>
        <Box className={classes.innerContainer}>
          <ContactBlock />
        </Box>
      </Box>
    </>
  );
}
